import { Flow_0_0_2 } from '@flexus/core';

export const SIL_98: Flow_0_0_2 = {
	id: '98',
	name: 'la_managing_job',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: '--'
		}
	},
	startNode: '',
	nodes: {}
};
